<template>
<div>

    <div class="container-fluid">
        <div class="row">

            <div class="col-lg-12">
                <div class="card box-margin">
                    <div class="card-header">
                        <i class="fas fa-th-large"></i><span> Tratado de datos</span>
                        <div class="btn-group" role="group">
                            <template v-if="AsignarRolPermisosByUsuario.includes('cliente_data.importar')">
                                <button type="button" class="btn btn-success" @click="abrirModal"><i class="far fa-file-excel"></i>Importar</button>
                            </template>
                            <template>
                                <button type="button" class="btn btn-info" @click="tranferencia()"><i class="fas fa-exchange-al"></i> Tranferir</button>
                            </template>
                        </div>

                    </div>
                    <div class="card-body">

                        <div class="shortcode-html">
                            <!-- Table Bordered -->
                            <div class="form-group row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="LeadName">Asesor</label>
                                            <input type="text" class="form-control" v-model="filtro.asesor"  placeholder="Buscar ...">
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="status-select" class="mr-2">Referencia</label>
                                            <select class="custom-select" v-model="filtro.referencia" id="status-select">
                                                <option value="0" >Seleccionar</option>
                                                <option v-for="red in list_referencia" :key="red.id" :value="red.id" v-text="red.nombre"></option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="LeadName">Cliente</label>
                                            <input type="text" class="form-control"  v-model="filtro.cliente"  placeholder="Buscar ...">
                                        </div>
                                    </div>
                                     <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="LeadName">Correo Electronico</label>
                                            <input type="text" class="form-control"  v-model="filtro.email"  placeholder="Buscar ...">
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="LeadName">Cedula</label>
                                            <input type="text" class="form-control"  v-model="filtro.cedula"  placeholder="Buscar ...">
                                        </div>
                                    </div>


                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="LeadName">Buscar</label>
                                             <button type="button" @click="listaTratarDatosCliente(1,pag_mostrar)" class="btn btn-primary form-control"><i class="fas fa-search"></i></button>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="LeadName">Limpiar</label>
                                             <button type="button" @click="cleanFiltros" class="btn btn-primary form-control"><i class="far fa-trash-alt"></i></button>
                                        </div>
                                    </div>
                            </div>
                            <div class="form-group row">

                                <div class="form-inline col-md-6 col-sm-12">
                                    <div class="form-group col">
                                        <label >Mostrar</label>
                                            <select v-model="pag_mostrar" class="form-control" v-on:change="listaTratarDatosCliente(1,pag_mostrar)">
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                        <label >registros por página</label>
                                    </div>
                                </div>


                            </div>

                            <div style="overflow: auto !important;">
                                    <div class="breadcrumb breadcrumb-bjar">
                                        <a v-for="es in estados_data" :key="es.nombre" href="#" :class="es.clase + ' hoveractive ' + ((filtro.active_estado == es.id) ? 'active' :'')" @click="activarHoveEstado(es.id)">
                                            <div class="breadcrumb__inner">
                                                <span class="breadcrumb__title" v-text="es.cantidad"></span>
                                                <span class="breadcrumb__desc" v-text="es.nombre"></span>
                                            </div>
                                        </a>
                                    </div>
                                </div>

                            <div  class="table-responsive">

                                <table class="table table-bordered" style="width:100% !important" id="ptable">
                                    <thead>
                                        <tr>
                                            <th><b>Acciones</b></th>
                                            <th><b>Fecha  y Hora</b></th>
                                            <th><b>Cliente</b></th>
                                            <th><b>Gestión</b></th>
                                            <th><b>Comentario</b></th>
                                            <th><b>Detalle</b></th>
                                        </tr>
                                    </thead>

                                    <tbody  v-if="listCategoria.length">
                                        <tr v-for="(c, index) in listCategoria" :key="index">

                                            <td>
                                                <div class="btn-group mb-2 mr-2">
                                                        <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-filter"></i> Acción</button>
                                                        <div class="dropdown-menu">
                                                            <!--  && c.estado != 'PRELIQUIDACION' || usuario.cargo == 'Administrador' -->
                                                            <template>
                                                                <button class="dropdown-item" @click="$router.push({name:'cliente_data_cotizacion.index', params:{id: c.id}})"><i class="fas fa-file-invoice text-info" ></i> Cotizar</button>
                                                            </template>

                                                            <template>
                                                                <button class="dropdown-item" @click="$router.push({name:'cliente_data.editar', params:{id: c.id}})"><i class="fa fa-edit text-info"></i> Editar</button>
                                                            </template>

                                                            <template>
                                                                <button class="dropdown-item"  @click="eliminarCliente(c.id)"><i class="fas fa-trash-alt text-danger"></i> Eliminar</button>
                                                            </template>

                                                        </div>
                                                </div>
                                            </td>

                                            <td>
                                                <p style="font-weight: bold;" v-text="c.fecha_human"></p>
                                                <p style="color: red; font-size: 15px;">AGREGADO EL:</p>
                                                <p style="font-weight: bold;" v-text="c.fecha"></p>
                                                <p style="font-weight: bold; font-size: 13px;" v-text="c.hora"></p>
                                                <p style="color: red; font-size: 15px;">ÚLTIMA GESTIÓN:</p>
                                                <p style="font-weight: bold;" v-text="c.ultima_fecha"></p>
                                                <p style="font-weight: bold; font-size: 13px;" v-text="c.ultima_hora"></p>
                                            </td>

                                            <td>
                                                <p style="font-weight: bold;" v-text="c.cliente"></p>
                                                <p style="font-weight: bold;" v-text="c.cliente_email"></p>
                                                <p><b style="color: blue; font-size: 16px;">Ref.</b> <span style="font-weight: bold;" v-text="c.referencia"></span></p>
                                                <p><b style="color: blue; font-size: 16px;">Asesor.</b> <span style="font-weight: bold;" v-text="c.asesor"></span></p>
                                                <a  class="btn btn-rounded btn-outline-success mb-2 mr-2" v-for="(tel, index_tel) in c.telefonos" :key="index_tel" :href="tel.wsp" target="_blank">
                                                    <i class="fab fa-whatsapp"></i>
                                                    {{ tel.telefono }}
                                                </a>
                                                <div class="badge badge-primary text-white" v-for="(tel, index_tel) in c.telefonos_comun" :key="index_tel"  v-text="tel.telefono"></div>

                                            </td>

                                            <td>
                                                <el-select class="bjar" v-model="c.estado" @change="cambiarEstado(c.id, c.estado)" filterable placeholder="Seleccionar">
                                                    <el-option  v-for="item in lista_estados" :key="item.id" :label="item.nombre" :value="item.id">
                                                    </el-option>
                                                </el-select>
                                            </td>

                                            <td style="font-weight: bold;" v-text="c.comentario">
                                            </td>

                                            <td>
                                                <p><b style="color: blue; font-size: 16px;">Ramo: </b> <span style="font-weight: bold;" v-text="c.vehiculo"></span></p>
                                                <p><b style="color: blue; font-size: 16px;">V.A: </b> <span style="font-weight: bold;" v-text="c.suma_asegurada"></span></p>
                                                <p><b style="color: blue; font-size: 16px;">Empresa: </b> <span style="font-weight: bold;" v-text="c.empresa"></span></p>

                                            </td>



                                        </tr>
                                    </tbody>
                                     <tbody v-else>
                                        <tr>
                                            <td colspan="23" align="center">
                                                <h5>No se encontraron resultados...</h5>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>


                            </div>
                                <nav style="float: left;">  Mostrando la página <span v-text="pagination.current_page"></span> de <span v-text="pagination.last_page"></span></nav>
                                 <nav style="float: right;">


                                    <ul class="pagination singel-page flex-wrap" >
                                        <li class="page-item" v-if="pagination.current_page > 1">
                                            <a class="page-link" @click.prevent="cambiarPagina(pagination.current_page - 1)" href="#">Anterior</a>
                                        </li>
                                        <li class="page-item" v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']">
                                            <a class="page-link" href="#"  @click.prevent="cambiarPagina(page)" v-text="page"></a>
                                        </li>
                                        <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                                            <a class="page-link" href="#"  @click.prevent="cambiarPagina(pagination.current_page + 1)">Siguiente</a>
                                        </li>
                                    </ul>
                                </nav>


                            <!-- End Table Bordered -->
                        </div>

                    </div>
                </div>
            </div>


        </div>

        <!--   Inicio modal Evidencia-------------------------------------------------------------->
        <div class="modal fade " :class="{ show: modalShow }" :style=" modalShow ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-md modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel">Importar - Excel</h5>
                        <button type="button" @click="abrirModal" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="LeadName">Archivo Excel</label>
                                    <input  vue-load-file @change="fileUploadeExcel"  class="form-control"  type="file" id="file"  accept=".XLSX" >

                                </div>
                            </div>
                             <div class="col-md-12">
                                <div class="form-group">
                                    <label for="LeadName" class="text-danger"><b>Nota*</b></label>
                                    <p>- Solo se permiten archivos Excel de formato <b>.xlsx</b>, Click <a href="/clientes-data-tratar/exportar"  target="_blank" >aquÍ</a> para descargar
                                    archivo modelo.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                     <div class="modal-footer">
                            <button type="button" v-if="actu_reg==0" class="btn btn-sm btn-primary" @click="importarExcel()">Importar</button>
                            <button type="button" class="btn btn-sm btn-secondary" @click="abrirModal">Cerrar</button>
                     </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
        <!--   Fin modal Evidencia-------------------------------------------------------------->

        <tranferencia-modal  @onClose="listaTratarDatosCliente(1, pag_mostrar)"></tranferencia-modal>
    </div>

</div>
</template>

<script>

import {alertasM} from '../../../util.js';
import Tranferencia from './componentes/Tranferrencia.vue';
export default {
    props: ['ruta'],
    components: {
            'tranferencia-modal' : Tranferencia,
    },
    data() {
        return {
            cCriterio: 'nombre',
            cBusqueda: '',
            filtro: {
                email           : '',
                cliente         : '',
                correo          : '',
                cedula          : '',
                asesor          : '',
                referencia      : 0,
                active_estado   : 0,

            },
            listCategoria: [],
            pagination : {
                    'total' : 0,
                    'current_page' : 0,
                    'per_page' : 0,
                    'last_page' : 0,
                    'from' : 0,
                    'to' : 0,
                },
            offset: 3,
            pag_mostrar: 5,//registros a mostrar por pagina tipo datable
            modalShow: false,

            mostrarModal: {
                display: 'block',
                background: '#0000006b'
            },
            ocultarModal: {
                display: 'none'
            },
            excel_cotizacion : '',
            vaCreCategoria:{
                eId: 0,
                cNombre: '',
                state: ''

            },
            tituloModal: '',
            nameButon: '',
            actu_reg: 0, //0 registrar - 1 actualizar
            AsignarRolPermisosByUsuario: JSON.parse(localStorage.getItem('listRolPermisosByUsuario')),
            list_referencia: [],

            lista_estados   : [
                {id: 'NO CONTACTADO', nombre : 'No contactado'},
                {id: 'NÚMERO INCORRECTO', nombre : 'Número incorrecto'},
                {id: 'EN GESTIÓN', nombre : 'En gestión'},
                {id: 'PROSPECTO', nombre : 'Prospecto'},
            ],
            estados_data : [],



        }
    },
    mixins: [alertasM],
    computed: {
            isActived: function() {
                return this.pagination.current_page;
            },
            //Calcula los elementos de la paginación
            pagesNumber: function() {
                if (!this.pagination.to) {
                    //si la pagina es diferente al ultimo elemento de la pagina actual, retornamos
                    return []; //Array vacio
                }

                var from = this.pagination.current_page - this.offset;
               // console.log("bengy: ", from);
                if (from < 1) {
                    //si la pagina actual es 0 entonces la igualamos  a uno
                    from = 1;
                }
                //la suma de la variable rom + el doble de la varialbe offset
                var to = from + this.offset * 2;
               // console.log("bengy2: ", from);
                if (to >= this.pagination.last_page) {
                    to = this.pagination.last_page;
                }

                var pagesArray = [];
                while (from <= to) {
                    /*   pagesArray.push(from);//Ocurre desbordamiento, cuando son muchos registros
                                from++; */
                    //Solucion
                    if (
                        (from >= this.pagination.current_page - 1) &
                        (from <= this.pagination.current_page + 3)
                    )
                        pagesArray.push(from);
                    from++;
                }
                return pagesArray;
            },
        },
    methods: {


        listaTratarDatosCliente(page,pag_mostrar){

          var url = '/clientes-data-tratar';
          this.openCargando();//Activamos pantalla de carga de bloqueo
          axios.get(url,{
              params:{
                  'filtro': JSON.stringify(this.filtro),
                  'page' : page,
                  'pag_mostrar': pag_mostrar
              }
          })
          .then(res => {
                var respuesta       = res.data;
                this.listCategoria  = respuesta.cliente;
                this.estados_data   = respuesta.estados
                this.pagination = respuesta.pagination;
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
          })
          .catch(err => {
              if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                       }
                    }
                console.error(err);
          })

        },

        activarHoveEstado(data){

            if(this.filtro.active_estado == data && this.filtro.active_estado != '0'){
                this.filtro.active_estado = '0';
            }else{
                this.filtro.active_estado = data;
            }

            this.listaTratarDatosCliente(1,this.pag_mostrar);

        },

        cambiarPagina(page) {
                let me = this;
                //Actualiza la página actual
                me.pagination.current_page = page;
                //Envia la petición para visualizar la data de esa página
                me.listaTratarDatosCliente(page,me.pag_mostrar);
        },

        abrirModal() {
            this.modalShow = !this.modalShow;

            if(this.modalShow==true){

                //this.tituloModal = "Registrar Categoria";
                //this.actu_reg = 0;
                //this.nameButon = "Guardar";

            }else{
               // this.aTipoDocumento = [];
                this.cleanVariables();
                this.excel_cotizacion = '';
                $("#file").val('');
            }
        },

        cleanVariables(){
            this.vaCreCategoria.cNombre = "";
            this.vaCreCategoria.eId = "";
        },

        importarExcel(){

            let me = this;
            let formData = new FormData();
            formData.append('file', me.excel_cotizacion);
            this.openCargando();
            var url = '/tratar-data-clientes/import';
            //Hacemos la peticion
            axios.post(url,formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
            .then(res => {
                this.openCargando(true);
                var respuesta = res.data;

                if(respuesta.status){
                    //me.$notie.alert(1, 'Requerimientos Importados Correctamente', 3);
                    this.notify("Datos importador correctamente","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                    this.listaTratarDatosCliente(1,this.pag_mostrar);
                    this.abrirModal();
                }else{
                     this.notify("Error al importar los datos ","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                }

            })
            .catch(err => {
               this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                this.notify("Error al importar los datos ","","top","center","fas fa-check-circle","danger",' flipInX','flipOutX')
               for(var key in err.response.data.errors){
                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
               if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                console.error(err);
            })

        },

        fileUploadeExcel(e){
            let me = this;
            let file_input =  e.target.files[0];
            me.excel_cotizacion = file_input
        },

        cleanFiltros(){
            this.filtro =  {
                email   : '',
                cliente : '',
                correo  : '',
                cedula  : '',
                asesor  : '',
                referencia: 0

            };
            this.listaTratarDatosCliente(1,this.pag_mostrar);
        },

        eliminarCliente(id){
            let me = this;

            me.swalWithBootstrapButtons.fire({
                title: '¿Está seguro de eliminar el Cliente?',
                //text: "You won't be able to revert this!",
                icon: 'error',
                showCancelButton: true,
                confirmButtonText: 'Si, eliminar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true
                }).then((result) => {

                    if(result.value){

                        var url = '/tratar-data-cliente/registrar-eliminar';
                        me.openCargando();

                        axios.post(url,{
                            'id': id,
                        })
                        .then(res => {
                            me.openCargando(true);

                            if(res.data.status){

                            this.notify(" Cliente eliminado con éxito","","top","center","fas fa-user-check","success",' flipInX','flipOutX')

                            }else{
                                this.notify(" Error al eliminar el cliente","","top","center","fas fa-user-check","danger",' flipInX','flipOutX')
                            }
                          this.listaTratarDatosCliente(1,this.pag_mostrar);
                        })
                        .catch(err => {
                            this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                             console.error(err);
                                if (err.response.status == 401) {
                                    this.$router.push({name: 'login'})
                                    location.reload();
                                    localStorage.clear();
                                }

                            })
                    }
                }
            )
        },

        getSelectTipoDoc(){

            var url = '/administracion/usuario/getListarDocumentos';

            axios.get(url)
            .then(res => {

                var respuesta           = res.data;
                this.list_referencia   = respuesta.referencia;

            })
            .catch(err => {

                console.error(err);
                 if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
            })
        },

        tranferencia(){
            EventBus.$emit( 'tranferencia-modal',  1);
        },

        async cambiarEstado(id, estado){
            let me = this;
            try {
                var url = '/clientes-data-tratar/cambiar-estado';
                let get = {
                    'id'        : id,
                    'estado'    : estado,
                };
                me.$pageLoad();
                let response            = await axios.get(url,{params:get});
                me.$pageLoad(true);
                me.notify(" Nuevo estado asignado","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
            } catch (error) {
                this.$mostrar_error(error);
            }
        }




    },
    mounted() {
            this.getSelectTipoDoc();
            this.listaTratarDatosCliente(1,this.pag_mostrar);


        },
}
</script>

<style>
    .breadcrumb-bjar{
        min-width: 1000px !important;
    }
    .table thead th {
        min-width: 200px !important;
    }
    #ptable tbody td p {
         margin-bottom: 0px !important;
    }
</style>
